import { PersonDataService } from "../../../core/persons.dataservice";
import { CompetenceGroupsService } from "../../../core/competencegroups.dataservice"
import { CompetenceTypeDataService } from "../../../core/competencetypes.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";

import { PersonCompetenceEditComponent } from "./person.competence.edit.component";
import { PersonCompetenceComponent } from "./person.competence.component";

import * as dataCore from "../../../core/datacore";

export const personCompetencesEditState: Ng2StateDeclaration = {
    name: "app.resources.persons.competences.edit",
    url: "/{personCompetenceId:int}/edit",
    views: {
        "main-view@app": {
            component: PersonCompetenceEditComponent
        }
    },
    resolve: {
        isNew: () => false,
        personCompetence: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonCompetence($stateParams.personCompetenceId);
        }],
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        competenceGroup: [
            CompetenceGroupsService.Id,
            CompetenceTypeDataService.Id,
            "personCompetence",
            function (competenceGroupDataService: CompetenceGroupsService, competenceTypeDataService: CompetenceTypeDataService, personCompetence: Nema.Crew.Model.PersonCompetence) {
                return competenceTypeDataService.get(personCompetence.CompetenceTypeId)
                    .then(competenceType => competenceGroupDataService.get(competenceType.CompetenceGroupId));
            }],
        competenceTypes: [
            CompetenceTypeDataService.Id,
            "competenceGroup",
            function (competenceTypeDataService: CompetenceTypeDataService, competenceGroup: Nema.Crew.Model.CompetenceGroup) {
                return competenceTypeDataService.getAll()
                    .then(competenceTypes => filterCompetenceTypesByGroupIdAndOrder(competenceTypes, competenceGroup.Id));
            }]
    }
};

export const personCompetencesNewState: Ng2StateDeclaration = {
    name: "app.resources.persons.competences.new",
    url: "/{competenceGroupId:int}/new",
    views: {
        "main-view@app": {
            component: PersonCompetenceEditComponent
        }
    },
    resolve: {
        isNew: () => true,
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        competenceGroup: [CompetenceGroupsService.Id, "$stateParams", function (competenceGroupDataService: CompetenceGroupsService, $stateParams) {
            return competenceGroupDataService.get($stateParams.competenceGroupId);
        }],
        competenceTypes: [CompetenceTypeDataService.Id, "$stateParams", function (competenceTypeDataService: CompetenceTypeDataService, $stateParams) {
            return competenceTypeDataService.getAll()
                .then(competenceTypes => filterCompetenceTypesByGroupIdAndOrder(competenceTypes, $stateParams.competenceGroupId));
        }],
        personCompetence: ["person", "competenceTypes", function (person: Nema.Crew.Model.Person, competenceTypes: Nema.Crew.Model.CompetenceType[]) {
            return <Nema.Crew.Model.PersonCompetence>{
                PersonId: person.Id,
                CompetenceTypeId: competenceTypes.length ? competenceTypes[0].Id : null,
                HasAttachment: false,
                IsValidated: false,
                ValidFrom: dataCore.getTodayUTC()
            };
        }]
    }
};

export const personCompetencesDetailsState: Ng2StateDeclaration = {
    name: "app.resources.persons.competences.detail",
    url: "/{personCompetenceId:int}",
    views: {
        "main-view@app": {
            component: PersonCompetenceComponent
        }
    },
    resolve: {
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        personCompetence: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonCompetence($stateParams.personCompetenceId);
        }]
    }
};

function filterCompetenceTypesByGroupIdAndOrder(competenceTypes: Nema.Crew.Model.CompetenceType[], competenceGroupId: number) {
    return dataCore.orderBySortTagThenName(competenceTypes.filter(competenceType => competenceType.CompetenceGroupId === competenceGroupId));
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/competences/person.competences.states.ts